import store from '../store/store';
import isLanguageSupported from './isLanguageSupported';

// If user has invalid target language selection, reverts option back to display language
export default function checkTargetLanguageValid() {
    if (!isLanguageSupported(store.settings.targetLanguage)) {
        store.settings.targetLanguage = '';
    }
}
